var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutbound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.9999V16.1999C21 17.88 21 18.7201 20.673 19.3619C20.3854 19.9263 19.9265 20.3853 19.362 20.6729C18.7202 20.9999 17.8802 20.9999 16.2 20.9999H7.8C6.11984 20.9999 5.27976 20.9999 4.63803 20.6729C4.07354 20.3853 3.6146 19.9263 3.32698 19.3619C3 18.7201 3 17.88 3 16.1999V14.9999M17 7.99988L12 2.99988M12 2.99988L7 7.99988M12 2.99988V14.9999",
    stroke: "url(#paint0_linear_3432_1078)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3432_1078",
    x1: 12,
    y1: 2.99988,
    x2: 12,
    y2: 20.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33C2B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5CE6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutbound);
export default __webpack_public_path__ + "static/media/Outbound.089cc2b04ae04972edc8c77235da22f5.svg";
export { ForwardRef as ReactComponent };